<template>
    <div>
    <ValidationProvider
        tag="div"
        :rules="rules"
        :name="vid"
        :label="label || name"
        :mode="mode"
        :model-value="modelValue"
        @update:model-value="handleInput($event)"
        :validate-on-mount="false"
        :validate-on-model-update="validateOnModelUpdate"
        v-slot="{ errors, value, handleChange }"
    >
        <b-form-group
            :label-for="name || labelText"
            :label="labelText"
            :class="{
                'mb-0': compactFormat,
                'compact-container': compactFormat
            }"
        >
            <b-input-group>
                <b-form-input
                    v-bind="$attrs"
                    ref="input"
                    :name="name"
                    :model-value="value"
                    @update:model-value="handleChange($event)"
                    step="any"
                    :state="errors.length ? false : null"
                    :class="{ 'compact-control': compactFormat }"
                ></b-form-input>
                <template v-slot:append v-if="infoMessage">
                    <b-input-group-text
                        class="px-1 info-append"
                        v-b-tooltip="{
                            title: infoMessage,
                            trigger: 'hover',
                            placement: 'auto',
                            boundary: 'viewport',
                            container: 'body',
                            teleportTo: 'body',
                            customClass: 'p-info-tooltip',
                            delay: { show: 0, hide: 100 }
                        }"
                    >
                        <b-icon-info-circle style="pointer-events: none;"></b-icon-info-circle>
                    </b-input-group-text>
                </template>
                <template v-slot:append v-else-if="$slots.append">
                    <slot name="append" />
                </template>
            </b-input-group>
            <span class="text-danger">{{ errors[0] }}</span>
        </b-form-group>
    </ValidationProvider>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import baseInputs from '@/components/mixins/BaseInputs';
import validatedInput from '@/components/mixins/ValidatedInput';

export default {
    name: 'p-input',
    mixins: [baseInputs, validatedInput],
    props: {
        // value prop now comes from modelValue via BaseInputs mixin
        debounceWait: {
            type: Number,
            default: 0
        },
        compactFormat: {
            type: Boolean,
            default: false
        },
        validateOnModelUpdate: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        value() { return this.modelValue; },
    },
    created() {
        if (this.debounceWait > 0) {
            this.handleInput = debounce(this.handleInput, this.debounceWait);
        }
    },
    methods: {
        focus: function() {
            this.$refs.input.focus();
        }
    }
};
</script>

<style scoped lang="scss">
:deep(.compact-control ) {
    padding-bottom: 5px;
    padding-top: 8px;
    padding-left: 2px;
    height: 1.5rem;
}
/* Info-icon append: drop the grey input-group-text box so the icon floats
   cleanly next to the field. */
:deep(.info-append) {
    background-color: transparent;
    border: none;
}
</style>

